import { render, staticRenderFns } from "./queryModal.vue?vue&type=template&id=99ddb0da&scoped=true&"
import script from "./queryModal.vue?vue&type=script&lang=js&"
export * from "./queryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ddb0da",
  null
  
)

export default component.exports